export default class Routes {
    static readonly DEFAULT = "/";
    static readonly MULTIPLY_BTC = "/home/multiply_btc";
    static readonly EARN_BTC = "/home/earn_btc";
    static readonly DAILY_LOTTERY = "/home/lottery";
    static readonly BITCOIN = "/bitcoin";
    static readonly SIGN_UP = "/signup";
    static readonly LOGIN = "/login";
    static readonly PASSWORD_RECOVERY = "/password_recovery";
    static readonly VERIFY_EMAIL = "/verify_email";
    static readonly TERMS_AND_CONDITIONS = "/terms_and_conditions";
    static readonly HOME = "/home";
    static readonly WELCOME = "/welcome";
    static readonly INVEST_BTC = "/home/invest_btc";
    static readonly FREE_BTC = "/home/free_btc";
    static readonly BITCOIN_NEWS = "/blogs";
    static readonly BITCOIN_PRICE = "/bitcoin_price";
    static readonly BITCOIN_WALLET = "/bitcoin_wallet";
    static readonly BITCOIN_ACCOUNT = "/bitcoin_account";
    static readonly PROMOTIONS = "/promotions";
    static readonly VERIFY_RESULTS = "/verifier";
    static readonly PROFILE = "/home/profile";
    static readonly TRANSACTIONS = "/home/transactions";
    static readonly REFERRALS = "/home/referrals";
}